import { Pipe, PipeTransform } from '@angular/core';
import { LogRecordStatus } from '@fleet-beat/core';

@Pipe({
  name: 'logRecordIcon',
})
export class LogRecordIconPipe implements PipeTransform {
  transform(value: `${LogRecordStatus}`): string | null {
    if (!value) return null;
    switch (value) {
      case LogRecordStatus.PowerOffConventional:
        return 'power_off';
      case LogRecordStatus.PowerOffReduced:
        return 'power_off';
      case LogRecordStatus.PowerOnConventional:
        return 'power_on';
      case LogRecordStatus.PowerOnReduced:
        return 'power_on';
      case LogRecordStatus.Certification:
        return 'signature';
      case LogRecordStatus.Login:
        return 'log_in';
      case LogRecordStatus.Logout:
        return 'log_out';
      default:
        return null;
    }
  }
}
